import { render, staticRenderFns } from "./FinishRegister.vue?vue&type=template&id=f357fdea&scoped=true&"
import script from "./FinishRegister.vue?vue&type=script&lang=ts&"
export * from "./FinishRegister.vue?vue&type=script&lang=ts&"
import style0 from "./FinishRegister.vue?vue&type=style&index=0&id=f357fdea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f357fdea",
  null
  
)

export default component.exports